import React from 'react'

export const ErrorPage = () => {
  return (
    <div>
      <h1>404 Not Found</h1>
    </div>
  )
}
